// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { wsc } from '../wsc';
import { CreateCodeTicketDto } from './dto/create-code-ticket.dto';
import { CreatedResponseDto } from './dto/created-response.dto';
import { FetchCodeDto } from './dto/fetch-code.dto';
import { FetchSentCodeDto } from './dto/fetch-sent-code.dto';
import { FetchUnusedCodeDto } from './dto/fetch-unused-code.dto';
import { ListTicketEventResponseDto } from './dto/list-ticket-event-response.dto';
import { ListTicketResponseDto } from './dto/list-ticket-response.dto';
import { ProfileDto } from './dto/profile.dto';
import { TicketListResponseBoxfulRowDto } from './dto/ticket-list-response-boxful-row.dto';
import { TicketListResponseCodeRowDto } from './dto/ticket-list-response-code-row.dto';
import { UpdateTicketDto } from './dto/update-ticket.dto';

export class GosuApiModel {
  // 取得獎品包清單
  static fetchTicketEventList(): Promise<ListTicketEventResponseDto[]> {
    return wsc.execute('/ws/gosu-api/fetchTicketEventList') as any;
  }

  // 新增獎品包
  static createTicketEvent(name: string): Promise<CreatedResponseDto> {
    return wsc.execute('/ws/gosu-api/createTicketEvent', name) as any;
  }

  // 更新獎品包
  static updateTicketEvent(ticketEventId: number, name: string): Promise<void> {
    return wsc.execute(
      '/ws/gosu-api/updateTicketEvent',
      ticketEventId,
      name,
    ) as any;
  }

  // 刪除獎品包
  static deleteTicketEvent(ticketEventId: number): Promise<void> {
    return wsc.execute('/ws/gosu-api/deleteTicketEvent', ticketEventId) as any;
  }

  // 取得獎品包下的獎品清單
  static fetchTicketList(
    ticketEventId: number,
  ): Promise<ListTicketResponseDto[]> {
    return wsc.execute('/ws/gosu-api/fetchTicketList', ticketEventId) as any;
  }

  //新增獎品
  static createTicket(data: CreateCodeTicketDto): Promise<CreatedResponseDto> {
    return wsc.execute('/ws/gosu-api/createTicket', data) as any;
  }

  //取得獎品
  static fetchTicket(
    ticketId: number,
  ): Promise<TicketListResponseCodeRowDto | TicketListResponseBoxfulRowDto> {
    return wsc.execute('/ws/gosu-api/fetchTicket', ticketId) as any;
  }

  // 更新獎品(名稱/移動至其他獎品包)
  static updateTicket(ticketId: number, data: UpdateTicketDto): Promise<void> {
    return wsc.execute('/ws/gosu-api/updateTicket', ticketId, data) as any;
  }

  // 刪除獎品
  static deleteTicket(ticketId: number): Promise<void> {
    return wsc.execute('/ws/gosu-api/deleteTicket', ticketId) as any;
  }

  // 指派獎品給參加者
  static assign(
    ticketId: number,
    participantId: number,
    reason: string,
  ): Promise<void> {
    return wsc.execute(
      '/ws/gosu-api/assign',
      ticketId,
      participantId,
      reason,
    ) as any;
  }

  // 取得獎品下的序號清單
  static fetchTicketCodes(
    ticketId: number,
    page: number,
    pageSize: number,
  ): Promise<FetchCodeDto> {
    return wsc.execute(
      '/ws/gosu-api/fetchTicketCodes',
      ticketId,
      page,
      pageSize,
    ) as any;
  }

  // 取得解碼的序號
  static fetchCode(
    ticketId: number,
    ticketCodeId: number,
  ): Promise<{ code: string; url: string }> {
    return wsc.execute('/ws/gosu-api/fetchCode', ticketId, ticketCodeId) as any;
  }

  // 新增獎品序號
  static createCodes(
    ticketId: number,
    codes: { url: string; code: string }[],
  ): Promise<{
    success: number;
    fail: number;
  }> {
    return wsc.execute('/ws/gosu-api/createCodes', ticketId, codes) as any;
  }

  // 下載並刪除序號
  static downloadAndDeleteUnusedCodes(
    ticketId: number,
  ): Promise<FetchUnusedCodeDto[]> {
    return wsc.execute(
      '/ws/gosu-api/downloadAndDeleteUnusedCodes',
      ticketId,
    ) as any;
  }

  // 刪除序號
  static deleteCodes(ticketId: number, ticketCodeIds: number[]): Promise<void> {
    return wsc.execute(
      '/ws/gosu-api/deleteCodes',
      ticketId,
      ticketCodeIds,
    ) as any;
  }

  // 取得已發送序號
  static fetchSentCodes(ticketId: number): Promise<FetchSentCodeDto[]> {
    return wsc.execute('/ws/gosu-api/fetchSentCodes', ticketId) as any;
  }

  // 取得未使用序號
  static fetchUnusedCodes(ticketId: number): Promise<FetchUnusedCodeDto[]> {
    return wsc.execute('/ws/gosu-api/fetchUnusedCodes', ticketId) as any;
  }

  // 取得好友
  static fetchProfileById(profileId: number): Promise<ProfileDto> {
    return wsc.execute('/ws/gosu-api/fetchProfileById', profileId) as any;
  }

  static sendAwardEmail(data: {
    winnerId: number;
    participantId: number;
    eventId: string;
    winningTime: string;
    award: string;
    email: string;
  }): Promise<{
    success: boolean;
    message: string;
  }> {
    return wsc.execute('/ws/gosu-api/sendAwardEmail', data) as any;
  }
}
// ac0bb4fa3fc5d9c51203b78f8ba576f4a568152d5b827dccf39a7e04ed9d2be2
